import React, { useCallback } from 'react';
import { SCREEN_STATE } from '../types';
import { ReactSVG } from 'react-svg';
import iconFull from '../images/icon_full.svg';
import iconScant from '../images/icon_scant.svg';
interface FullScreenSelectProps {
    screenState: SCREEN_STATE;
    onFullScreenToggle: () => void;
}

export const FullScreenSelect: React.FC<FullScreenSelectProps> = (props) => {
    const { screenState = 'no-full', onFullScreenToggle } = props;
    const handleFullScreenToggle = useCallback(
        (e: React.MouseEvent<any>) => {
            e.preventDefault();
            e.stopPropagation();
            onFullScreenToggle();
        },
        [onFullScreenToggle],
    );
    return (
        <div className="umu-pdf-toolbar-section-left umu-pdf-mobile-hide">
            <ReactSVG
                src={String(screenState) === 'full' ? iconScant : iconFull}
                className="toolbar-icon-screen"
                onClick={handleFullScreenToggle}
            />
        </div>
    );
};
